<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template
        v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :class="{'submenu-title-noDropdown':!isNest}" :index="resolvePath(onlyOneChild.path)">
          <!--<i :class="onlyOneChild.meta.icon || (item.meta&&item.meta.icon)|| 'el-icon-apple'"></i>-->
          <i class="el-icon-s-promotion"></i>
          {{onlyOneChild.meta.title }}
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <i class="el-icon-s-promotion"></i>
        {{item.meta.title }}
        <!--<item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title"/>-->
      </template>
      <sidebar-item
          v-for="child in item.children" v-if="!child.hidden"
          :key="child.path"
          :base-path="resolvePath(child.path)"
          :is-nest="true"
          :item="child"
          class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import * as validate from '@/core/utils/validate'
import AppLink from './Link'

export default {
  name: 'SidebarItem',
  components: {AppLink},
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {}
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = {...parent, path: '', noShowingChildren: true}
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (validate.external(routePath)) {
        return routePath
      }
      return path.resolve(this.basePath, routePath)
    },
  }
}
</script>
